import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import ContactHero from "../../assets/contact.jpg";
import emailjs from "@emailjs/browser";
import {
  FaTimes,
  FaCheck,
} from "react-icons/fa";

const Contact = () => {
  const form = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null); // 'success' or 'error'
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalMessage, setModalMessage] = useState("");




  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const result = await emailjs.sendForm(
        "service_ynxsiyf",
        "template_6nk0a2f",
        form.current,
        "yI2IoGVhugkTFtnK1",
      );

      if (result.text === "OK") {
        setModalType("success");
        setModalMessage(
          "Message sent successfully! You will receive a response soon.",
        );
        setIsModalOpen(true);
        e.target.reset();
      } else {
        throw new Error("Failed to send message");
      }
    } catch (error) {
      console.error("EmailJS Error:", error);
      setModalType("error");
      setModalMessage(
        "Failed to send message. Please try again in a few moments.",
      );
      setIsModalOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalType(null);
    setModalMessage("");
  };

  return (
    <>
      <Helmet>
        <title>Medichy | Contact</title>
        <meta
          name="description"
          content="Medichy is a modern digital medical and healthcare platform delivering reliable medical and healthcare solutions."
        />
      </Helmet>
      <TheContact>
        <div className="contact-hero-section">
          <img src={ContactHero} alt="page banner" />
          <div className="overlay"></div>
          <div className="hero-content">
            <h1>Contact Us</h1>
            <p>Get in touch with our team for inquiries and support</p>
          </div>
        </div>

        <div className="contact-container">
          <div className="get-in-touch">
            <div className="contact-form-section">
              <div className="form-header">
                <h2>Send us a message</h2>
                <p>
                  Fill out the form below and we'll get back to you as soon as
                  possible.
                </p>
              </div>

              <form ref={form} onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="user_name">
                      Full Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="user_name"
                      name="user_name"
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="user_email">
                      Email Address <span className="required">*</span>
                    </label>
                    <input
                      type="email"
                      id="user_email"
                      name="user_email"
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="user_country">Country/Region</label>
                  <input
                    type="text"
                    id="user_country"
                    name="user_country"
                    placeholder="Enter your country"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">
                    Subject <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="What is this regarding?"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">
                    Message <span className="required">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Please provide details of your inquiry..."
                    rows="6"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                  {!isSubmitting && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.473-7.493Z" />
                    </svg>
                  )}
                </button>
              </form>
            </div>

            <div className="contact-info-section">
              <div className="contact-info-card">
                <h3>Get in Touch</h3>
                <p className="info-description">
                  We're here to help and answer any questions you might have.
                </p>

                <div className="contact-details">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                      </svg>
                    </div>
                    <div>
                      <p className="contact-label">Phone Number</p>
                      <a href="tel:+13022133509" className="contact-value">
                       +1 302 213 3509
                      </a>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                      </svg>
                    </div>
                    <div>
                      <p className="contact-label">Email Address</p>
                      <a
                        href="mailto:sales@medichy.com"
                        className="contact-value"
                      >
                        sales@medichy.com
                      </a>
                      <a
                        href="mailto:support@medichy.com"
                        className="contact-value"
                      >
                        support@medichy.com
                      </a>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-1.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                        <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                      </svg>
                    </div>
                    <div>
                      <p className="contact-label">Office Address</p>
                      <p className="contact-value">
                        1496 McKee & Joanna Crescent Rd, Dover, DE 19901
                      </p>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1A7 7 0 1 1 8 1a7 7 0 0 1 0 14z" />
                      </svg>
                    </div>
                    <div>
                      <p className="contact-label">Business Hours</p>
                      <p className="contact-value">
                        Mon - Fri: 9:00 AM - 6:00 PM EST
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TheContact>

      {/* Modal Popup */}
      {isModalOpen && (
        <ModalOverlay onClick={closeModal}>
          <ModalContent
            onClick={(e) => e.stopPropagation()}
            modalType={modalType}
          >
            <ModalHeader modalType={modalType}>
              {modalType === "success" ? <FaCheck /> : <FaTimes />}
              <button className="close-btn" onClick={closeModal}>
                <FaTimes />
              </button>
            </ModalHeader>
            <ModalBody>
              <h3>{modalType === "success" ? "Success!" : "Error!"}</h3>
              <p>{modalMessage}</p>
              <button className="modal-btn" onClick={closeModal}>
                {modalType === "success" ? "Continue" : "Try Again"}
              </button>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

const TheContact = styled.div`
  width: 100%;
  min-height: 100vh;

  .contact-hero-section {
    position: relative;
    height: 60vh;
    width: 100%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(0, 100, 200, 0.7) 0%,
        rgba(0, 50, 150, 0.8) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      width: 90%;
      max-width: 800px;

      h1 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 1rem;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
      }

      p {
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.9;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
      }
    }
  }

  .contact-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .get-in-touch {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: start;
  }

  .contact-form-section {
    .form-header {
      margin-bottom: 2.5rem;

      h2 {
        font-size: 2.5rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 0.75rem;
      }

      p {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
      }
    }

    form {
      .form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1.5rem;
        margin-bottom: 1.5rem;
      }

      .form-group {
        margin-bottom: 1.5rem;

        label {
          display: block;
          font-size: 1rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 0.5rem;

          .required {
            color: #e53e3e;
            margin-left: 2px;
          }
        }

        input,
        textarea {
          width: 100%;
          padding: 0.875rem 1rem;
          font-size: 1rem;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          transition: all 0.3s ease;
          background: #fff;

          &:focus {
            outline: none;
            border-color: #3182ce;
            box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
          }

          &::placeholder {
            color: #a0aec0;
          }
        }

        textarea {
          resize: vertical;
          min-height: 120px;
        }
      }

      .submit-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
        color: white;
        border: none;
        padding: 1rem 2rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        width: 100%;

        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(49, 130, 206, 0.3);
        }

        &:active:not(:disabled) {
          transform: translateY(0);
        }

        &:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        svg {
          transition: transform 0.3s ease;
        }

        &:hover:not(:disabled) svg {
          transform: translateX(4px);
        }
      }
    }
  }

  .contact-info-section {
    .contact-info-card {
      background: #f8fafc;
      border-radius: 16px;
      padding: 2.5rem;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      border: 1px solid #e2e8f0;

      h3 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 1rem;
      }

      .info-description {
        color: #666;
        font-size: 1.1rem;
        line-height: 1.6;
        margin-bottom: 2.5rem;
      }

      .contact-details {
        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          margin-bottom: 2rem;

          &:last-child {
            margin-bottom: 2.5rem;
          }

          .contact-icon {
            width: 48px;
            height: 48px;
            background: #edf2f7;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            svg {
              color: #3182ce;
            }
          }

          .contact-label {
            font-size: 0.9rem;
            color: #718096;
            margin-bottom: 0.25rem;
            font-weight: 500;
          }

          .contact-value {
            font-size: 1.1rem;
            color: #1a1a1a;
            font-weight: 600;
            text-decoration: none;
            display: block;

            &:hover {
              color: #3182ce;
            }
          }

          a.contact-value {
            color: #3182ce;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .social-links {
        border-top: 1px solid #e2e8f0;
        padding-top: 2rem;

        p {
          color: #666;
          font-size: 1rem;
          margin-bottom: 1rem;
          font-weight: 500;
        }

        .social-icons {
          display: flex;
          gap: 1rem;

          a {
            width: 44px;
            height: 44px;
            background: #edf2f7;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;

            &:hover {
              background: #3182ce;
              transform: translateY(-2px);

              svg {
                color: white;
              }
            }

            svg {
              color: #4a5568;
              transition: color 0.3s ease;
              font-size: 1.25rem;
            }
          }
        }
      }
    }
  }

  /* Media Queries */
  @media screen and (max-width: 1366px) {
    .contact-hero-section {
      height: 55vh;
    }
    .contact-container {
      padding: 3.5rem 1.5rem;
    }
    .get-in-touch {
      gap: 3.5rem;
    }
  }

  @media screen and (max-width: 1200px) {
    .get-in-touch {
      gap: 3rem;
    }
    .contact-form-section .form-header h2 {
      font-size: 2.25rem;
    }
    .contact-info-section .contact-info-card {
      padding: 2rem;
      h3 {
        font-size: 1.75rem;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .get-in-touch {
      grid-template-columns: 1fr;
      gap: 4rem;
    }
    .contact-hero-section {
      height: 50vh;
    }
    .contact-container {
      padding: 3rem 1.5rem;
    }
  }

  @media screen and (max-width: 600px) {
    .contact-hero-section {
      height: 45vh;
      .hero-content h1 {
        font-size: 2.5rem;
      }
    }
    .contact-container {
      padding: 2.5rem 1rem;
    }
    .contact-form-section {
      .form-header h2 {
        font-size: 2rem;
      }
      form .form-row {
        grid-template-columns: 1fr;
        gap: 0;
        margin-bottom: 0;
      }
    }
    .contact-info-section .contact-info-card {
      padding: 1.75rem;
      h3 {
        font-size: 1.5rem;
      }
    }
  }

  @media screen and (max-width: 420px) {
    .contact-hero-section {
      height: 40vh;
      .hero-content h1 {
        font-size: 2rem;
      }
    }
    .contact-container {
      padding: 2rem 0.75rem;
    }
    .contact-form-section .form-header h2 {
      font-size: 1.75rem;
    }
    .contact-info-section .contact-info-card {
      padding: 1.5rem;
    }
  }

  @media screen and (max-width: 350px) {
    .contact-hero-section {
      height: 35vh;
      .hero-content h1 {
        font-size: 1.75rem;
      }
    }
  }
`;

// Modal Components
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  width: 90%;
  max-width: 450px;
  overflow: hidden;
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 600px) {
    width: 95%;
  }
`;

const ModalHeader = styled.div`
  padding: 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);;
  color: white;
  position: relative;

  svg {
    font-size: 3rem;
  }

  .close-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: rotate(90deg);
    }
  }
`;

const ModalBody = styled.div`
  padding: 2rem;
  text-align: center;

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 0.75rem;
  }

  p {
    font-size: 1rem;
    color: #4a5568;
    line-height: 1.5;
    margin-bottom: 1.5rem;
  }

  .modal-btn {
    background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(49, 130, 206, 0.3);
    }
  }

  @media (max-width: 600px) {
    padding: 1.5rem;

    h3 {
      font-size: 1.25rem;
    }

    p {
      font-size: 0.9rem;
    }
  }
`;

export default Contact;
